type ExcelJsModule = typeof import("exceljs");

/**
 * `exceljs` is CommonJS. Vite's browser build exposes both named exports and a
 * `default`, while under Node only `default` is populated. Normalising here keeps
 * the engine usable outside the browser.
 */
function resolveModule(namespace: ExcelJsModule): ExcelJsModule {
    return (namespace as ExcelJsModule & { default?: ExcelJsModule }).default ?? namespace;
}

// Cache the promise rather than the resolved module so concurrent callers share one fetch.
let excelJsPromise: Promise<ExcelJsModule> | null = null;

export default function loadExcelJs() {
    excelJsPromise ??= import("exceljs").then(resolveModule);

    return excelJsPromise;
}
